export const ErrorIcon = () => {
  return (
    <svg
      width="484"
      height="241"
      viewBox="0 0 484 241"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M124.332 100.062C124.332 92.4318 131.283 86.2461 139.857 86.2461H344.59C353.164 86.2461 360.115 92.4317 360.115 100.062V194.184C360.115 201.814 353.164 208 344.59 208H139.857C131.283 208 124.332 201.814 124.332 194.184V100.062Z"
        fill="#BCBDC2"
      />
      <path
        d="M115.398 75.2816C115.398 66.5311 122.876 59.4375 132.1 59.4375H352.358C361.583 59.4375 369.06 66.5311 369.06 75.2816V183.219C369.06 191.97 361.583 199.064 352.358 199.064H132.1C122.876 199.064 115.398 191.97 115.398 183.219V75.2816Z"
        fill="#E4E5E9"
      />
      <rect
        x="106.457"
        y="32.6289"
        width="271.541"
        height="157.498"
        rx="13.7401"
        fill="white"
      />
      <rect
        x="188.125"
        y="139.883"
        width="117.104"
        height="36.2291"
        rx="12"
        transform="rotate(-45 188.125 139.883)"
        fill="#FF80AB"
      />
      <rect
        x="213.617"
        y="57.6055"
        width="117.104"
        height="36.2291"
        rx="12"
        transform="rotate(45 213.617 57.6055)"
        fill="#FF80AB"
      />
    </svg>
  );
};
